import React from "react";
import { Loader2 } from "lucide-react";
import JsonModal from "./JsonModal";

export default function LogsTable({ logs, loading }) {
    const [openJson, setOpenJson] = React.useState(false);
    const [jsonData, setJsonData] = React.useState(null);

    const formatTime = (value) => {
        if (!value) return "-";
        const d = new Date(value);
        d.setHours(d.getHours() + 7);
        return d.toLocaleTimeString("vi-VN", { hour12: false });
    };

    const formatPush = (v) =>
        v === null || v === undefined ? "-" : `${v.toFixed(2)}s`;

    const parseJson = (log) => {
        try {
            const body = log.request_body;
            const parsed = typeof body === "string" ? JSON.parse(body) : body;
            setJsonData(parsed);
        } catch {
            setJsonData(log.request_body);
        }
    };

    return (
        <div className="bg-white border border-gray-200 rounded-2xl overflow-hidden shadow-sm">
            <div className="overflow-x-auto">
                <table className="min-w-full text-sm">
                    <thead className="bg-primary text-xs uppercase text-white">
                        <tr>
                            <th className="px-3 py-2">Time</th>
                            <th className="px-3 py-2">pushTimeAPI</th>
                            <th className="px-3 py-2">Message ID</th>
                            <th className="px-3 py-2">FT Code</th>
                            <th className="px-3 py-2">Terminal</th>
                            <th className="px-3 py-2">Status</th>
                            <th className="px-3 py-2 text-right">Request ID</th>
                        </tr>
                    </thead>

                    <tbody>
                        {!loading && logs.length === 0 && (
                            <tr>
                                <td
                                    colSpan={7}
                                    className="text-center py-4 text-gray-500 bg-gray-50"
                                >
                                    Không có dữ liệu.
                                </td>
                            </tr>
                        )}

                        {loading && (
                            <tr>
                                <td
                                    colSpan={7}
                                    className="py-6 text-center text-gray-500 bg-gray-50"
                                >
                                    <Loader2
                                        size={20}
                                        className="animate-spin mx-auto"
                                    />
                                </td>
                            </tr>
                        )}

                        {!loading &&
                            logs.map((log) => (
                                <tr
                                    key={log.request_id}
                                    className={`border-t border-gray-100 text-gray-700 ${
                                        log.is_slow
                                            ? "bg-red-500 hover:bg-orange-100"
                                            : "hover:bg-primary/5"
                                    } transition-colors`}
                                >
                                    <td className="px-3 py-2">
                                        {formatTime(log.created_at)}
                                    </td>
                                    <td className="px-3 py-2 font-mono text-center text-xs">
                                        {formatPush(log.push_time)}
                                    </td>
                                    <td className="px-3 py-2 font-mono text-xs">
                                        {log.client_message_id || "-"}
                                    </td>
                                    <td className="px-3 py-2">
                                        {log.ft_code || "-"}
                                    </td>
                                    <td className="px-3 py-2">
                                        {log.terminal_id || "-"}
                                    </td>

                                    {/* === CHỈ SỬA PHẦN NÀY === */}
                                    <td className="px-3 py-2">
                                        <button
                                            className="px-3 py-1 bg-primary text-white rounded text-xs hover:bg-blue-700"
                                            onClick={() => {
                                                parseJson(log);
                                                setOpenJson(true);
                                            }}
                                        >
                                            Xem JSON
                                        </button>
                                    </td>

                                    <td className="px-3 py-2 font-mono text-right text-xs">
                                        {log.request_id}
                                    </td>
                                </tr>
                            ))}
                    </tbody>
                </table>
            </div>

            {/* MODAL JSON */}
            <JsonModal
                open={openJson}
                onClose={() => setOpenJson(false)}
                data={jsonData}
            />
        </div>
    );
}
